export const wpClassNames = {
    BLOCK_CONTAINER: 'wp-block-cdm-customizations-accountslist',
    BLOCK_ITEM_CONTAINER: 'wp-block-cdm-customizations-accountitem',
    BLOCK_ITEM_ICON: 'accountListItemIcon',
    BLOCK_ITEM_TITLE: 'accountListItemTitle',
    BLOCK_ITEM_SUBTITLE: 'accountListItemSubtitle',
    BLOCK_ITEM_ICON_CONTAINER: "cdm-account-item-block-svg-icon"
};